import script from "./Cancellations.vue?vue&type=script&setup=true&lang=js"
export * from "./Cancellations.vue?vue&type=script&setup=true&lang=js"

import "./Cancellations.vue?vue&type=style&index=0&id=35901fd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35901fd2"]])

export default __exports__